import React from 'react';
import c from 'classnames';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import ParagraphUrgencySubparagraph from '../UrgencySubparagraph';

import './style.scss';

const ParagraphUrgency = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const subparagraphs = entity.getIn(['field_subparagraphs']);
  const singleUrgency = !subparagraphs.getIn([1]);

  const subparagraphClasses = c('ParagraphUrgency__subparagraph', {
    'ParagraphUrgency__subparagraph--one col-12': subparagraphs.size === 1,
    'ParagraphUrgency__subparagraph--two col-12 col-md-6':
      subparagraphs.size === 2,
    'ParagraphUrgency__subparagraph--three col-12 col-md-4':
      subparagraphs.size >= 3,
  });

  return (
    <Container className="Paragraph ParagraphUrgency">
      <div className="row">
        <div className="col-12">
          <div
            className={`
          ${singleUrgency ? 'singleUrgency' : ''}`}
          >
            {title && <h2>{title}</h2>}
            <div className="row">
              {subparagraphs && (
                subparagraphs.map((item, index) => {
                  const subparagraphEntity = item.get('entity');
                  const entityId = item.get('target_id');

                  return (
                    <div key={entityId} className={subparagraphClasses}>
                      <ParagraphUrgencySubparagraph
                        singleUrgency={singleUrgency}
                        id={entityId}
                        entity={subparagraphEntity}
                      />
                    </div>
                  );
                }))}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphUrgency;
